export const brandsColumns = [
  {
    accessorKey: "brand_image",
    header: "Image",
    width: 100,
    Cell: ({ cell }) => {
      const imageUrl = `https://api.ebn.ng/public${cell.getValue()}`; // Construct full image URL
      return (
        <div>
          <img src={imageUrl} alt="Brand" width={50} />
        </div>
      );
    },
  },
  {
    accessorKey: "brand_name", //access nested data with dot notation
    header: "Brand Name",
  },
];

